var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-component',{attrs:{"model_name":"employee","show_previus_days":false}})}
var staticRenderFns = []

export { render, staticRenderFns }